var ils;
(function (ils) {
    function loadMapScripts(callbackFunction) {
        var googleMapsScript = document.createElement('script');
        var markerClustererScript = document.createElement('script');
        var infoBoxScript = document.createElement('script');
        var showcaseMapsScript = document.createElement('script');
        googleMapsScript.src = `${ils.googleMapsSrc}&callback=onGoogleMapsLoaded`;
        googleMapsScript.async = true;
        markerClustererScript.setAttribute("src", ils.markerClustererSrc);
        infoBoxScript.setAttribute("src", ils.infoBoxSrc);
        showcaseMapsScript.setAttribute("src", ils.showcaseMapSrc);
        showcaseMapsScript.onload = async function () {
            if (!globalThis.mapsAreInitialized) {
                initMapScripts();
                const callbackCheckPromise = new Promise((resolve) => {
                    setTimeout(async () => {
                        if (callbackFunction) {
                            await callbackFunction();
                        }
                        resolve();
                    }, 50);
                });
                await callbackCheckPromise;
            }
            document.querySelector(".map-tools .instructions").addEventListener('click', function () {
                var drawingHelpElement = document.querySelector(".map-tools .drawing-help");
                drawingHelpElement.style.display = drawingHelpElement.style.display === "none" ? "" : "none";
                return false;
            });
        };
        markerClustererScript.onload = function () {
            document.body.appendChild(infoBoxScript);
        };
        infoBoxScript.onload = function () {
            document.body.appendChild(showcaseMapsScript);
        };
        /**
         * Callback function for when Google Maps is loaded. This is defined in the script tag
         * src attribute as a query parameter.
         */
        globalThis.onGoogleMapsLoaded = function () {
            document.body.appendChild(markerClustererScript);
        };
        // Append the Google Maps script tag to the body so we trigger the download of the script
        document.body.appendChild(googleMapsScript);
    }
    ils.loadMapScripts = loadMapScripts;
    if (globalThis.initialItems && globalThis.initialItems.length > 0) {
        ils.showcaseListings.viewModel.TotalRowCount(globalThis.initialItems[0].TotalRowCount);
        ils.showcaseListings.viewModel.Listings(globalThis.initialItems);
        if (polygonCoordinates) {
            // Since polygon coordinates can only be decoded by the browser (using Google maps javascript sdk), the 
            // initial server load will not be able to apply that filter. For that reason, we need to load a new
            // set of items after the initial load is done.
            var polygontimeout = setTimeout(async function () {
                // Wait for the initial load to finish.
                while (globalThis.isInitialLoad || ils.showcaseListings.viewModel.LazyLoadedListings().length > 0) {
                    await new Promise((resolve) => setTimeout(resolve, 100));
                }
                // Reset the lazy loaded listings and page number to 1 so that we can start fresh
                ils.showcaseListings.viewModel.LazyLoadedListings([]);
                ils.showcaseListings.viewModel.PageNumber(1);
                // Load a new first page of items by calling LoadNextSet
                await ils.showcaseListings.LoadNextSet();
                // Set the initialItems value to the new set of items. We do this because we're basically
                // starting the page load over again.
                globalThis.initialItems = ils.showcaseListings.viewModel.Listings();
                // Set the isInitialLoad flag to true so that the next time we load a new set of items, we don't 
                // go to the server, but instead use the initialItems value.
                globalThis.isInitialLoad = true;
                // Kick off a LoadNewSet call so that we can run through the pages of results
                await ils.showcaseListings.LoadNewSet();
                clearTimeout(polygontimeout);
            }, 500);
        }
    }
    function initMapScripts() {
        ils.showcaseListings.initializeMap();
        // Pins load after this. bounds is still empty here, and fitBounds on an empty
        // LatLngBounds centers the map at latitude 0, longitude 180. Leave the
        // neighborhood center from initializeMap until real pins are fitted.
        globalThis.mapsAreInitialized = true;
        globalThis.loadingMaps = false;
    }
    ils.initMapScripts = initMapScripts;
})(ils || (ils = {}));
